import React from 'react';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';
import { BrandColor } from '@Shared.Angular/@types/brandColor';
import {
  Card,
  CardProps
} from '@Shared.Angular/flowingly.components/Card/card';
import { CreationHubHeader } from './CreationHubHeader';

type CreationHubItemGroup = {
  title: string;
  iconClass?: string;
  color: BrandColor;
  label: string;
  items: CardProps[];
};

type CreationHubPickerProps = {
  title: string;
  description: string;
  groups: CreationHubItemGroup[];
};

export const CreationHubPicker = ({
  title,
  description,
  groups
}: CreationHubPickerProps) => {
  return (
    <div className="creation-hub-picker">
      <CreationHubHeader title={title} description={description} />
      {groups.filter(Boolean).map((group) => (
        <div key={group.title} className="creation-hub-picker__group">
          <div
            className={`creation-hub-picker__group-header creation-hub-picker__group-header--${group.color}`}
          >
            {group.iconClass && (
              <i
                className={`fa-light ${group.iconClass} creation-hub-picker__group-icon`}
              />
            )}
            <span className="creation-hub-picker__group-title">
              {group.title}
            </span>
            <Chip name={group.label} brandColor={group.color} />
          </div>
          <div className="creation-hub-picker__grid">
            {group.items.filter(Boolean).map((item) => (
              <Card key={item.title} {...item} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
